import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import Permissions from 'react-redux-permissions';
import { compose } from 'recompose';

import { FabButtonLink } from '@fd/ui/FabButtonLink';

import Spacer from '../../../../ui/Spacer';

type AddNewLinkButtonProps = {
  fdKey: string;
  to?: string;
  text: TranslationId;
};

export const CreateNewLinkButton = ({ to, text, fdKey }: AddNewLinkButtonProps) => {
  if (!to) {
    return null;
  }

  return (
    <Fab
      variant="extended"
      color="secondary"
      to={to}
      data-fd={fdKey}
      component={FabButtonLink}
      style={{
        position: 'fixed',
        right: '24px',
        bottom: '24px',
      }}
    >
      <AddIcon />
      <Spacer size={8} variant="vertical" />
      <Translate id={text} />
    </Fab>
  );
};

export const CreateAppStoreAppLink = ({ toUrl }: { toUrl?: string }) => (
  <CreateNewLinkButton
    fdKey="Create_new_app_store_app"
    text="Create_new_app_store_app"
    to={toUrl}
  />
);

type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => {
  const { currentApp, locale } = state;
  const toUrl = `/${currentApp.AppId}/appstore/developers/new`;
  return {
    toUrl,
  };
};

export default compose<MappedState, {}>(connect(mapStateToProps))((props) => (
  <Permissions allowed={['Owner']}>
    <CreateAppStoreAppLink {...props} />
  </Permissions>
));
